import TextField from 'share-ui/components/TextField/TextField'
import styled from 'styled-components'

import { ButtonPrimary } from 'components/Button/Button'

import BasicContentLoader from 'components/ContentLoaders/BasicContentLoader'
import { useChat } from './useChat'

import { StyledChatWrapper, StyledContainer, StyledMainWrapper } from 'routes/ChatRouteLayout'
import { StyledAppContainer } from 'components/Layout/LayoutStyle'
import ChatMarkdown from './Markdown/ChatMarkdown'

const Chat = () => {
    const { isLoading, messages, setInputValue, inputValue, handleSendMessage } = useChat()

    return (
        <StyledAppContainer>
            <StyledContainer>
                <StyledMainWrapper>
                    <StyledChatWrapper>
                        <>
                            <>
                                <StyledChatBody>
                                    {isLoading && <BasicContentLoader />}

                                    {messages?.type === 'text' && (
                                        <ChatMarkdown>{messages?.text}</ChatMarkdown>
                                    )}
                                </StyledChatBody>
                                <StyledFooterInput>
                                    <TextField
                                        placeholder='What would you like to know?'
                                        onChange={setInputValue}
                                    />
                                    <ButtonPrimary
                                        onClick={() =>
                                            handleSendMessage(
                                                inputValue,
                                                ['Google Image Search', 'Google Search'],
                                                '',
                                                '',
                                                '',
                                            )
                                        }
                                    >
                                        Send
                                    </ButtonPrimary>
                                </StyledFooterInput>
                            </>
                        </>
                    </StyledChatWrapper>
                </StyledMainWrapper>
            </StyledContainer>
        </StyledAppContainer>
    )
}

export default Chat

const StyledChatBody = styled.div`
    width: 100%;
    height: calc(100% - 100px);
    display: flex;
    flex-direction: column;

    overflow: auto;

    padding: 0 20px;
`
const StyledFooterInput = styled.div`
    height: 50px;
    width: 100%;

    display: flex;
    align-items: center;
    gap: 10px;

    margin-top: auto;

    padding: 0 20px;
`
